import type { Filling } from "../types/filling"

/**
 * The three ways to spend the sheet's leftover: `compact` keeps one grid and
 * leaves the rest outside it, `evenly` puts the same gap everywhere,
 * `distribute` spreads the lines and the pages on them to the edges.
 */
export const FILLING_LIST: Filling[] = [
  { id: "compact", name: "FILLING_COMPACT" },
  { id: "evenly", name: "FILLING_EVENLY" },
  { id: "distribute", name: "FILLING_DISTRIBUTE" },
]
